import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, isNotNullable } from '@spartacus/core';
import { Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { MyAddressBookService } from 'src/app/services/feature/kb-My-Address-Book/kb-my-address-book.service';

@Component({
  selector: 'app-update-address',
  templateUrl: './update-address.component.html',
  styleUrls: ['./update-address.component.scss'],
  standalone: false
})
export class UpdateAddressComponent {
  private unsubscribe$ = new Subject<void>();
  isMobile: boolean = false;
  update: any;
  regions: any;
  addressId: any;
  sub = new Subscription();
  constructor(private breakpointObserver: BreakpointObserver,
    private service: MyAddressBookService,
    private cdr: ChangeDetectorRef,
    private globalMsgService: GlobalMessageService,
    private activatedRoute: ActivatedRoute,
    protected router: Router) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  pwdchangeForm = new FormGroup(
    {
      companyName: new FormControl(null, [Validators.required]),
      line1: new FormControl(null, [Validators.required]),
      companyAddressTwo: new FormControl(null),
      regionIso: new FormControl(null, { validators: Validators.required }),
      townCity: new FormControl(null, [Validators.required]),
      postcode: new FormControl(null, [Validators.required]),
      countryIso: new FormControl(null, [Validators.required]),
      addressId: new FormControl(null)
    },
  );
  get pwdform() {
    return this.pwdchangeForm.controls;
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap.pipe(takeUntil(this.unsubscribe$)).subscribe((params) => {
      this.addressId = params.get('Id');
      this.service.getEditableAddress(this.addressId).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
        this.update = res?.supportedcountries;
        this.pwdform.countryIso.setValue(res.address?.country?.isocode);
        this.updateState();
        this.pwdchangeForm.patchValue({
          companyName: res.address?.companyName,
          line1: res.address?.line1,
          companyAddressTwo: res.address?.companyAddressTwo,
          regionIso: res.address?.region?.isocode,
          townCity: res.address?.town,
          postcode: res.address?.postalCode,
          addressId: this.addressId,
        });

        this.cdr.detectChanges();
      })
    })

  }
  onSubmit() {
    if (this.pwdchangeForm.invalid) {
      const key = 'common.form_global_error';
      this.globalMsgService.add({ key: key }, GlobalMessageType.MSG_TYPE_ERROR);
      this.pwdchangeForm.markAllAsTouched();
    }
    //make Api call
    else {

      this.service.updateEditedAddress(this.pwdchangeForm.value).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
        if (res) {
          if (res?.message?.status == 'SUCCESS') {
            this.globalMsgService.add({ key: res.message.message }, GlobalMessageType.MSG_TYPE_INFO);
          }
        }
      })
    }
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.sub.unsubscribe();
  }
  redirector() {
    this.router.navigate(['/address-book']);
  }
  updateState() {
    const iscode = this.pwdform.countryIso.value;
    this.sub.add(this.service.getRegions(iscode).subscribe((res: any) => {
      this.regions = res.regionsWSList;
    }));
  }
}
